import { motion } from 'framer-motion';
import styles from './Footer.module.css';

const LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {/* Top section */}
        <motion.div
          className={styles.top}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          {/* Brand */}
          <div className={styles.brand}>
            <a href="#hero" aria-label="Back to top">
              <div className={styles.logoScript}>Shobha</div>
              <div className={styles.logoSub}>Salon</div>
            </a>
            <p className={styles.tagline}>
              "Bharatpur's most trusted name in beauty — for over 25 years."
            </p>
            <div className={styles.socialRow}>
              <a
                href="https://www.instagram.com/shobha.salon/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialBtn}
              >
                Instagram
              </a>
              <a
                href="https://wa.me/918890469900"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialBtn}
              >
                WhatsApp
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <div className={styles.colTitle}>Quick Links</div>
            <ul className={styles.linkList}>
              {LINKS.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className={styles.colTitle}>Contact</div>
            <div className={styles.contactInfo}>
              <a
                href="tel:+918890469900"
                className={styles.contactLine}
              >
                📞 +91 88904 69900
              </a>
              <a
                href="https://wa.me/918890469900"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.contactLine}
              >
                💬 WhatsApp
              </a>
              <span className={styles.contactLine}>
                📍 Bharatpur, Rajasthan
              </span>
              <a
                href="https://www.instagram.com/shobha.salon/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.contactLine}
              >
                📸 @shobha.salon
              </a>
            </div>
          </div>
        </motion.div>

        {/* Bottom bar */}
        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © 2025 Shobha Beauty Parlour. All rights reserved.
          </p>
          <p className={styles.credits}>
            Bharatpur, Rajasthan · Best Bridal Makeup Artist Bharatpur
          </p>
        </div>
      </div>
    </footer>
  );
}
